<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="40%">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="120px">
    <div>
      <el-form-item label="用户" prop="userId">
        <div class="funding">
          <div style="width: 100%;">
            <el-select @change="selectFund()" v-model="dataForm.userId" placeholder="请选择" filterable clearable style="width:100%">
              <el-option v-for="item in fundList" :key="item.userId" :label="item.userName" :value="item.userId">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="IP地址" prop="ipCidr">
        <el-input style="width: 100%;" v-model="dataForm.ipCidr" placeholder="支持IP、IP段或通配符"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <div class="funding">
          <div style="width: 100%;">
            <el-select @change="selectstatus()" v-model="dataForm.status" placeholder="请选择" style="width:100%">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>  
          </div>
        </div>
      </el-form-item>
      <el-form-item label="跳过IP检查" prop="skipIpCheck">
        <el-radio-group v-model="dataForm.skipIpCheck">
          <el-radio :label="0">不跳过</el-radio>
          <el-radio :label="1">跳过</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <!-- 只在选择跳过时显示时间选择器 -->
      <template v-if="dataForm.skipIpCheck === 1">
        <el-form-item label="生效开始时间" prop="skipIpStartTime">
          <el-date-picker
            v-model="dataForm.skipIpStartTime"
            type="datetime"
            placeholder="选择生效开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
            :picker-options="startDatePickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="生效结束时间" prop="skipIpEndTime">
          <el-date-picker
            v-model="dataForm.skipIpEndTime"
            type="datetime"
            placeholder="选择生效结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
            :picker-options="endDatePickerOptions">
          </el-date-picker>
        </el-form-item>
      </template>
      
      <el-form-item label="备注" prop="remark">
        <el-input style="width: 100%;" v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
    </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      fundList: [],
      statusList: [
        { value: 0, label: '失效' },
        { value: 1, label: '有效' }
      ],
      dataForm: {
        id: '',
        userId: '',
        ipCidr: '',
        status: '',
        remark: '',
        skipIpCheck: 0,  
        skipIpStartTime: '',  
        skipIpEndTime: '' 
      },
      dataRule: {
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        ipCidr: [
          { required: true, message: '支持IP、IP段或通配符不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '1=生效,0=失效不能为空', trigger: 'blur' }
        ],
        remark: [
          { required: false, message: '备注不能为空', trigger: 'blur' }
        ],
        skipIpStartTime: [
          { 
            required: true, 
            message: '请选择跳过IP检查生效开始时间', 
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (this.dataForm.skipIpCheck === 1 && !value) {
                callback(new Error('请选择跳过IP检查生效开始时间'));
              } else {
                callback();
              }
            }
          }
        ],
        skipIpEndTime: [
          { 
            required: true, 
            message: '请选择跳过IP检查生效结束时间', 
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (this.dataForm.skipIpCheck === 1 && !value) {
                callback(new Error('请选择跳过IP检查生效结束时间'));
              } else {
                callback();
              }
            }
          }
        ]
      }
    }
  },
  computed: {
    // 添加日期选择器选项
    startDatePickerOptions() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.dataForm.skipIpEndTime) {
            return time.getTime() > new Date(self.dataForm.skipIpEndTime).getTime();
          }
          return false;
        }
      };
    },  
    endDatePickerOptions() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.dataForm.skipIpStartTime) {
            const startDate = new Date(self.dataForm.skipIpStartTime);
            startDate.setHours(0, 0, 0, 0);
            const selectedDate = new Date(time);
            selectedDate.setHours(0, 0, 0, 0);
            return selectedDate.getTime() < startDate.getTime();
          }
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        }
      };
    }
  },
  watch: {
    // 监听跳过IP检查选项变化
    'dataForm.skipIpCheck': {
      handler(newVal) {
        if (newVal === 0) {
          // 如果选择不跳过，清空时间字段
          this.dataForm.skipIpStartTime = '';
          this.dataForm.skipIpEndTime = '';
          
          // 延迟清除验证状态，避免触发其他字段验证
          setTimeout(() => {
            if (this.$refs.dataForm) {
              this.$refs.dataForm.clearValidate(['skipIpStartTime', 'skipIpEndTime']);
            }
          }, 100);
        }
      }
    }
  },
  created() {
    this.$http.get('/sys/user/queryUserList').then(res => {
      this.fundList = res.data.data;
    });
  },
  methods: {
    init(id) {
      this.dataForm.id = id || '';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields();
        if (this.dataForm.id) {
          this.$http.get(`/system/ip/info/${this.dataForm.id}`)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.dataForm = {
                ...this.dataForm,
                ...res.data,
              };
            }).catch(() => {});
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http[!this.dataForm.id ? "post" : "put"](
            `/system/ip/${!this.dataForm.id ? 'save' : 'update'}`,
            this.dataForm
          ).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit('refreshDataList');
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    selectFund() {
      this.dataForm.userName = this.fundList.find(
        item => item.userId == this.dataForm.userId)
          .userName
      },
      selectstatus() {
          this.dataForm.status = this.statusList.find(
          item => item.value == this.dataForm.status).value
      }
  }
}
</script>